import axios from 'axios';

export const ADMIN_SLUG = 'secret-admin-9b045436';
export const ADMIN_BASE = `/${ADMIN_SLUG}`;
export const ADMIN_LOGIN_PATH = `${ADMIN_BASE}/login`;

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith(ADMIN_BASE)) {
      localStorage.removeItem('admin_token');
      if (!window.location.pathname.endsWith('/login')) {
        window.location.href = ADMIN_LOGIN_PATH;
      }
    }
    return Promise.reject(err);
  }
);

export const assetUrl = (urlOrPath) => {
  if (!urlOrPath) return '';
  if (urlOrPath.startsWith('http://') || urlOrPath.startsWith('https://')) return urlOrPath;
  return `${process.env.REACT_APP_BACKEND_URL}${urlOrPath}`;
};

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || 'Something went wrong';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(' ');
  if (detail.msg) return detail.msg;
  return String(detail);
};

export default api;
